import React, { PropTypes } from "react/lib/React";
import styles from './reminderEmailStatusDialog.scss'
import Modal from 'react-modal'
import i18n from 'lib/i18n'

const _ = i18n('reminderStatus')

const customStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.75)',
    },
    content: {
        position: 'relative',
        top: 'initial',
        bottom: 'initial',
        left: 'initial',
        right: 'initial',
        maxHeight: '90%',
        overflow: 'auto',
        padding: '0',
    },
}

export default class ReminderEmailStatusDialog extends React.Component {
    static propTypes = {
        isOpen: PropTypes.bool.isRequired,
        success: PropTypes.bool.isRequired,
        invitationBlocked: PropTypes.bool.isRequired,
        closeModal: PropTypes.func.isRequired
    }

    constructor(props) {
        super(props)
        this.state = {}
    }

    /**
    *  This function render the success / fail modal for manual reminder email sender.
    */
    reminderConfirmationModalContent() {
        const { closeModal, success, invitationBlocked } = this.props
        return (
            <div className={styles.modalContent}>
                <span className={styles.title}>{_('reminderConfirmationModalTitle')}</span>
                <span className={styles.message}>{invitationBlocked ? _("invitationEmailBlockMessage") : (success ? _("reminderConfirmationModalSuccess") : _("reminderConfirmationModalFail"))}</span>
                <div className={styles.modalButtons}>
                    <div className={styles.greyButton + " enabled"}
                        onClick={() => closeModal()}
                    >
                        {_('ok')}
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const { isOpen } = this.props
        return (
            <Modal
                isOpen={isOpen}
                style={customStyles}
                key={"reminderConfirmationModalKey"}
                contentLabel={""}
            >
                {this.reminderConfirmationModalContent()}
            </Modal>
        )
    }

}


// WEBPACK FOOTER //
// ./components/DSDocuments/reminderEmailStatusDialog.jsx